import React from 'react';

const Nav = () => (
  <div id="nav">
    <a
      href=""
      target="_blank"
    >
      link one
    </a>
    <div id="nav-div">|</div>
    <a
      href=""
      target="_blank"
    >
      link two
    </a>
    <div id="nav-div">|</div>
    <a
      href=""
      target="_blank"
    >
      link three
    </a>
    <div id="nav-div">|</div>
    <a
      href=""
      target="_blank"
    >
      link four
    </a>
    <div id="nav-div">|</div>
    <a
      href=""
      target="_blank"
    >
      link five
    </a>
    <div id="nav-div">|</div>
    <a
      href=""
      target="_blank"
    >
      link six
    </a>
    <div id="nav-div">|</div>
    <a
      href=""
      target="_blank"
    >
      link seven
    </a>
    <div id="nav-div">|</div>
    <a
      href=""
      target="_blank"
    >
      link eight
    </a>
    <div id="nav-div">|</div>
    <a
      href=""
      target="_blank"
    >
      link nine
    </a>
    <div id="nav-div">|</div>
    <a
      href=""
      target="_blank"
    >
      link ten
    </a>
  </div>
);

export default Nav;
